const state = {
  NO_BOX: 'NO_BOX',
  PAST_SEASON: 'PAST_SEASON',
  PRE_PROCESSING: 'PRE_PROCESSING',
  PROCESSING: 'PROCESSING',
  ASSIGNED: 'ASSIGNED',
  SHIPPED: 'SHIPPED',
  DELIVERED: 'DELIVERED',
  PROB_DELIVERED: 'PROBABLY_DELIVERED',
};

export const showOrderSummaryStates = [state.PROCESSING, state.PRE_PROCESSING];

export const assignedStates = [
  state.ASSIGNED,
  state.SHIPPED,
  state.DELIVERED,
  state.PROB_DELIVERED,
  state.PAST_SEASON,
];

export default state;
